<template>
  <div class="ja-conversion-rates">
    <div class="ja-conversion-rates__header">
      <h3 class="ja-conversion-rates__title">Conversion Rates</h3>
      <p class="ja-conversion-rates__subtitle">Stage drop-offs across the funnel</p>
    </div>
    <div class="ja-conversion-rates__chart">
      <ja-apex-chart
        type="radialBar"
        :height="280"
        :options="chartOptions"
        :series="series"
      />
      <div class="ja-conversion-rates__center">
        <span class="ja-conversion-rates__center-value">{{ payRate }}%</span>
        <span class="ja-conversion-rates__center-label">Pay rate</span>
      </div>
    </div>
    <div class="ja-conversion-rates__legend">
      <div
        v-for="rate in rates"
        :key="rate.label"
        class="ja-conversion-rates__legend-item"
      >
        <span class="ja-conversion-rates__dot" :style="{ background: rate.color }" />
        <span class="ja-conversion-rates__legend-label">{{ rate.label }}</span>
        <span class="ja-conversion-rates__legend-value">{{ rate.value }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
import JaApexChart from "./JaApexChart.vue";

export default {
  name: "ConversionRatesChart",
  components: { JaApexChart },
  props: {
    rates: { type: Array, required: true },
  },
  computed: {
    series() {
      return this.rates.map((r) => r.value);
    },
    payRate() {
      const pay = this.rates.find((r) => r.label === "Pay rate");
      return pay ? pay.value : 0;
    },
    chartOptions() {
      return {
        chart: {
          type: "radialBar",
          sparkline: { enabled: false },
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
            },
            track: {
              background: "#f3f2f7",
              strokeWidth: "100%",
            },
            dataLabels: {
              name: { show: false },
              value: { show: false },
            },
          },
        },
        colors: this.rates.map((r) => r.color),
        labels: this.rates.map((r) => r.label),
        legend: { show: false },
        stroke: { lineCap: "round" },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.ja-conversion-rates {
  background: #fff;
  border-radius: 14px;
  padding: 1.5rem;
  box-shadow: 0 2px 12px rgba(34, 41, 47, 0.06);
  border: 1px solid #f0f0f5;
  height: 100%;
  position: relative;

  &__header {
    margin-bottom: 0.5rem;
  }

  &__title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #5e5873;
    margin: 0 0 0.25rem;
  }

  &__subtitle {
    font-size: 0.8rem;
    color: #b9b9c3;
    margin: 0;
  }

  &__chart {
    position: relative;
  }

  &__center {
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
  }

  &__center-value {
    display: block;
    font-size: 1.75rem;
    font-weight: 700;
    color: #5e5873;
    line-height: 1.2;
  }

  &__center-label {
    display: block;
    font-size: 0.8rem;
    color: #b9b9c3;
  }

  &__legend {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: -1rem;
  }

  &__legend-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__legend-label {
    color: #6e6b7b;
    flex: 1;
  }

  &__legend-value {
    font-weight: 600;
    color: #5e5873;
  }
}
</style>
